import {Pipe, PipeTransform} from '@angular/core';


@Pipe({
  name: 'productosIva',
})
export class ProductosIvaPipe implements PipeTransform {

  transform(items: any[], productos: any[]): any[] {

    if (items) {

      if (!productos || productos.length === 0) {
        return [];
      }

      return items.filter((iva) => productos.some((producto) => producto.iva === iva.iva));

    }

  }

}



// WEBPACK FOOTER //
// ./src/pipes/albaranes/productos-iva.ts